// TODO: 本来使用的是4.x版本的mqtt，但是会在IE中白屏；
// 暂时降级到3.0.0版本的mqtt，并且引入路径必须从dist引入才可支持IE；

// 3.0.0版本对部分mqtts/wss协议的支持目测不太完善，出现过无法连接的情况
// 但针对目前使用的mica-mqtt是没有问题的；
// import mqtt from 'mqtt/dist/mqtt';

import { decrypt } from '@/tool/crypto';
import { getProfile } from '@/tool/profile';
import { isDevEnv } from '@/tool/tool';

// eslint-disable-next-line import/no-cycle
import { keyboxMiddleware } from './keybox';
// eslint-disable-next-line import/no-cycle
import { keycabinetMiddleware } from './keycabinet';

let mqttModule = null;
// 存储mqtt加载状态（避免重复加载，防止多次调用connect时重复发起请求）
let mqttLoadingPromise = null;

export const subscribeTopics = {
  DASHBOARD_STATISTIC: 'dashboard/statistics',
  DASHBOARD_CHART: 'dashboard/chart',
  DASHBOARD_MAP_LOCKS: 'dashboard/map/locks',
  DASHBOARD_MAP_WORKERS: 'dashboard/map/workers',
  DASHBOARD_LATEST_UNLOCK: 'dashboard/unlockdatas',
  DASHBOARD_LATEST_SETTING: 'dashboard/settingdatas',

  BI_STATISTIC: 'bi/statistics',
  BI_KEYBOX_STATISTIC: 'bi/keybox/statistics',
  BI_KEYBOX_TAKEOUTIN: 'bi/keybox/takeoutin',
  BI_TASK_DATAS: 'bi/task/datas',
  BI_LOCKSWITCH_RECORDS: 'bi/lockswitch/records',
  BI_ANALYZEDATA_CHART: 'bi/analyzedata/chart',
  BI_TASK_DOWNLOAD: 'bi/task/download',

  DASHBOARD_LATEST_TASKS: 'dashboard/tasks',
  // 最新授权记录
  DASHBOARD_LATEST_AUTHORITYS: 'dashboard/authoritys',

  KEY_USAGE: 'keydatas',
  LOCK_SWITCH: 'lockdatas',

  LOCK_EVENT_DATA: 'lockeventdatas',

  TASKS: 'tasks',
  TASKS_DOWNLOAD: 'keytasks',

  // 用户待审批开关锁申请数量
  APPROVALS: 'approvals',

  ELC_DOORDATAS: '/elc/doordatas',
  // 报警记录
  ELC_ALARMDATAS: '/elc/alarmdatas/records',
  // 机柜信息
  ELC_CABINETS: '/elc/cabinets',
  // 首页报警提醒
  ELC_DASHBOARD_ALARMDATAS: '/elc/alarmdatas',
  // 箱变锁服务状态
  ELC_SERVICE_STATUS: '/elc/service/running',
};

console.log('mqtt dev', isDevEnv());
const config = {
  host: isDevEnv() ? '192.168.1.107' : window.location.hostname,

  // 这里的protocol和port只是默认值，服务端返回的mqtt信息优先级更高
  protocol: window.location.protocol === 'https:' ? 'mqtts' : 'mqtt', // 也可使用 wss : ws
  port: '60083',
  username: 'lock',
  password: 'cec79e44167030ab4ef35a46bc593dbf',
};

// = mqtt.connect(null, { reconnectPeriod: 10000000000000000000 });

// 事件监听器存储器
// 订阅事件后，以事件名字为键，回调函数为值储存（目前仅支持单个回调，
// TODO: 后续可升级为回调数组，兼容多组件同时订阅一个事件的需求）；
const messageHandler = {};

// eslint-disable-next-line import/no-mutable-exports
export let client;

const loadMqttModule = async () => {
  // 如果已经加载过，直接返回
  if (mqttModule) {
    return mqttModule;
  }
  // 如果正在加载，等待加载完成
  if (mqttLoadingPromise) {
    return mqttLoadingPromise;
  }
  // 开始动态加载mqtt
  mqttLoadingPromise = import('mqtt/dist/mqtt')
    .then(module => {
      mqttModule = module.default || module; // 兼容不同导出格式
      return mqttModule;
    })
    .catch(err => {
      console.error('加载mqtt模块失败:', err);
      throw err; // 抛出错误，让connect函数处理
    });
  return mqttLoadingPromise;
};

export const connect = async callback => {
  try {
    const mqtt = await loadMqttModule();
    const {
      protocol: defaultProtocol,
      host,
      port: defaultport,
      username: defaultusername,
      password: defaultpassword,
    } = config;
    const username = getProfile().mqtt?.username || defaultusername;
    const password = getProfile().mqtt?.password || defaultpassword;
    const finalProtocol = getProfile().mqtt?.protocol || defaultProtocol;
    const finalPort = getProfile().mqtt?.port || defaultport;
    const url = `${finalProtocol}://${host}:${finalPort}`;
    console.log(`mqtt url:`, url);
    client = mqtt.connect(url, {
      // rejectUnauthorized: false,
      username,
      password: decrypt(password),
      // reconnectPeriod: 24 * 60 * 60 * 1000 // 设置的大一点防止一直重连
    });

    client.on('connect', () => {
      console.warn('mqtt connected');
      if (callback) callback(null);
    });
    client.on('error', err => {
      console.warn('subs disconnect', err);
      if (callback) callback(err);
    });

    // 是否有权限监听消息
    // 1. 用户为admin
    // 2. 用户所在部门为该消息所在部门的同级或上级部门
    const authMessage = deptcode => {
      const userDept = getProfile().dept;
      // console.log('mqtt', userDept, deptcode);
      return !userDept || deptcode.startsWith(userDept.deptcode);
    };

    client.on('message', (topic, payload) => {
      // 如果是非普通主题（钥匙盒主题，直接进行分发）
      // console.warn('mqtt msg', topic, payload.toString());
      if (topic.startsWith('/vanma/keybox')) {
        keyboxMiddleware(topic, JSON.parse(payload.toString()));
        return;
      }
      if (topic.startsWith('/vanma/key-cabinet')) {
        keycabinetMiddleware(topic, JSON.parse(payload.toString()));
        return;
      }
      // 首页报警推送
      if (topic == '/elc/alarmdatas') {
        const alarmdata = JSON.parse(payload);
        const loginUserDeptcode = getProfile().dept?.deptcode;
        if (
          loginUserDeptcode === null ||
          loginUserDeptcode === undefined ||
          alarmdata.deptcode.indexOf(loginUserDeptcode) !== -1
        ) {
          const handler = messageHandler[topic];
          if (handler) handler(alarmdata);
        }

        return;
      }
      // 大屏钥匙盒钥匙柜企业id推送
      if (topic == 'bi/keybox/statistics') {
        const companyid = JSON.parse(payload);
        const loginUserCompanyid = getProfile().companyid;
        if (companyid === loginUserCompanyid) {
          const handler = messageHandler[topic];
          if (handler) handler(payload);
        }
        return;
      }

      if (authMessage(payload.toString())) {
        const handler = messageHandler[topic];
        if (handler) handler(payload);
      }
    });
  } catch (e) {
    console.warn('mqtt error', e);
    if (callback) callback(e);
  }
};

export const disconnect = () => {
  if (client && client.connected) {
    client.removeAllListeners();
    // 加入200ms延时，防止相关页面的unsubsribe还没执行完毕就断开连接导致控制台报错
    setTimeout(() => {
      client.end(true, null, () => {
        console.warn('mqtt disconnected');
      });
    }, 200);
  }
};

// export const subscribe = (events, callback) => {
//     client.subscribe(events, (err) => {
//         if (callback) callback(err);
//     })
// }

// export const unsubscribe = (events, callback) => {
//     client.unsubscribe(events, (err) => {
//         if (callback) callback(err);
//     })
// }

// export const listenMessage = (listener) => {
//     client.on('message', (topic, payload) => {
//         listener(topic, payload);
//     })
// }

// export const unlistenMessage = (listener) => {
//     client.off('message', listener);
// }

// 机柜信息
export const subscribeELCCabinet = callback => {
  client.subscribe(subscribeTopics.ELC_CABINETS, err => {
    console.log('mqtt add', 'ELC_CABINETS', err);
    if (!err) messageHandler[subscribeTopics.ELC_CABINETS] = callback;
    else console.warn(err);
  });
};

export const unsubscribeELCCabinet = () => {
  client.unsubscribe(subscribeTopics.ELC_CABINETS, err => {
    console.log('mqtt remove', 'ELC_CABINETS', err);
    if (!err) messageHandler[subscribeTopics.ELC_CABINETS] = null;
    else console.warn(err);
  });
};

export const subscribeStatistics = callback => {
  client.subscribe(subscribeTopics.DASHBOARD_STATISTIC, err => {
    console.log('mqtt add', 'DASHBOARD_STATISTIC', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_STATISTIC] = callback;
    else console.warn(err);
  });
};

export const unsubscribeStatistics = () => {
  client.unsubscribe(subscribeTopics.DASHBOARD_STATISTIC, err => {
    console.log('mqtt remove', 'DASHBOARD_STATISTIC', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_STATISTIC] = null;
    else console.warn(err);
  });
};

export const subscribeChart = callback => {
  client.subscribe(subscribeTopics.DASHBOARD_CHART, err => {
    console.log('mqtt add', 'DASHBOARD_CHART', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_CHART] = callback;
    else console.warn(err);
  });
};

export const unsubscribeChart = () => {
  client.unsubscribe(subscribeTopics.DASHBOARD_CHART, err => {
    console.log('mqtt remove', 'DASHBOARD_CHART', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_CHART] = null;
    else console.warn(err);
  });
};

export const subscribeMapLocks = callback => {
  client.subscribe(subscribeTopics.DASHBOARD_MAP_LOCKS, err => {
    console.log('mqtt add', 'DASHBOARD_MAP_LOCKS', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_MAP_LOCKS] = callback;
    else console.warn(err);
  });
};

export const unsubscribeMapLocks = () => {
  client.unsubscribe(subscribeTopics.DASHBOARD_MAP_LOCKS, err => {
    console.log('mqtt remove', 'DASHBOARD_MAP_LOCKS', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_MAP_LOCKS] = null;
    else console.warn(err);
  });
};

export const subscribeMapWorkers = callback => {
  client.subscribe(subscribeTopics.DASHBOARD_MAP_WORKERS, err => {
    console.log('mqtt add', 'DASHBOARD_MAP_WORKERS', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_MAP_WORKERS] = callback;
    else console.warn(err);
  });
};

export const unsubscribeMapWorkers = () => {
  client.unsubscribe(subscribeTopics.DASHBOARD_MAP_WORKERS, err => {
    console.log('mqtt remove', 'DASHBOARD_MAP_WORKERS', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_MAP_WORKERS] = null;
    else console.warn(err);
  });
};

export const subscribeLatestUnlock = callback => {
  client.subscribe(subscribeTopics.DASHBOARD_LATEST_UNLOCK, { qos: 1 }, err => {
    console.log('mqtt add', 'DASHBOARD_LATEST_UNLOCK', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_LATEST_UNLOCK] = callback;
    else console.warn(err);
  });
};

export const unsubscribeLatestUnlock = () => {
  client.unsubscribe(subscribeTopics.DASHBOARD_LATEST_UNLOCK, err => {
    console.log('mqtt remove', 'DASHBOARD_LATEST_UNLOCK', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_LATEST_UNLOCK] = null;
    else console.warn(err);
  });
};

export const subscribeLatestSetting = callback => {
  client.subscribe(subscribeTopics.DASHBOARD_LATEST_SETTING, { qos: 1 }, err => {
    console.log('mqtt add', 'DASHBOARD_LATEST_SETTING', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_LATEST_SETTING] = callback;
    else console.warn(err);
  });
};

export const unsubscribeLatestSetting = () => {
  client.unsubscribe(subscribeTopics.DASHBOARD_LATEST_SETTING, err => {
    console.log('mqtt remove', 'DASHBOARD_LATEST_SETTING', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_LATEST_SETTING] = null;
    else console.warn(err);
  });
};

export const subscribeKeyUsage = callback => {
  client.subscribe(subscribeTopics.KEY_USAGE, err => {
    console.log('mqtt add', 'KEY_USAGE', err);
    if (!err) messageHandler[subscribeTopics.KEY_USAGE] = callback;
    else console.warn(err);
  });
};

export const unsubscribeKeyUsage = () => {
  client.unsubscribe(subscribeTopics.KEY_USAGE, err => {
    console.log('mqtt remove', 'KEY_USAGE', err);
    if (!err) messageHandler[subscribeTopics.KEY_USAGE] = null;
    else console.warn(err);
  });
};

export const subscribeLockSwitch = callback => {
  client.subscribe(subscribeTopics.LOCK_SWITCH, err => {
    console.log('mqtt add', 'LOCK_SWITCH', err);
    if (!err) messageHandler[subscribeTopics.LOCK_SWITCH] = callback;
    else console.warn(err);
  });
};

export const unsubscribeLockSwitch = () => {
  client.unsubscribe(subscribeTopics.LOCK_SWITCH, err => {
    console.log('mqtt remove', 'LOCK_SWITCH', err);
    if (!err) messageHandler[subscribeTopics.LOCK_SWITCH] = null;
    else console.warn(err);
  });
};

export const subscribeLockEventData = callback => {
  client.subscribe(subscribeTopics.LOCK_SWITCH, err => {
    console.log('mqtt add', 'LOCK_EVENT_DATA', err);
    if (!err) messageHandler[subscribeTopics.LOCK_EVENT_DATA] = callback;
    else console.warn(err);
  });
};

export const unsubscribeLockEventData = () => {
  client.unsubscribe(subscribeTopics.LOCK_SWITCH, err => {
    console.log('mqtt remove', 'LOCK_EVENT_DATA', err);
    if (!err) messageHandler[subscribeTopics.LOCK_EVENT_DATA] = null;
    else console.warn(err);
  });
};

export const subscribeELCCabinetDoorSwitch = callback => {
  client.subscribe(subscribeTopics.ELC_DOORDATAS, err => {
    console.log('mqtt add', 'ELC_DOORDATAS', err);
    if (!err) messageHandler[subscribeTopics.ELC_DOORDATAS] = callback;
    else console.warn(err);
  });
};

export const unsubscribeELCCabinetDoorSwitch = () => {
  client.unsubscribe(subscribeTopics.ELC_DOORDATAS, err => {
    console.log('mqtt remove', 'ELC_DOORDATAS', err);
    if (!err) messageHandler[subscribeTopics.ELC_DOORDATAS] = null;
    else console.warn(err);
  });
};

export const subscribeApprovals = callback => {
  client.subscribe(subscribeTopics.APPROVALS, err => {
    console.log('mqtt add', 'APPROVALS', err);
    if (!err) messageHandler[subscribeTopics.APPROVALS] = callback;
    else console.warn(err);
  });
};

export const unsubscribeApprovals = () => {
  client.unsubscribe(subscribeTopics.APPROVALS, err => {
    console.log('mqtt remove', 'APPROVALS', err);
    if (!err) messageHandler[subscribeTopics.APPROVALS] = null;
    else console.warn(err);
  });
};

export const subscribeELCAlarmDatas = callback => {
  client.subscribe(subscribeTopics.ELC_ALARMDATAS, err => {
    console.log('mqtt add', 'ELC_ALARMDATA', err);
    if (!err) messageHandler[subscribeTopics.ELC_ALARMDATAS] = callback;
    else console.warn(err);
  });
};

export const unsubscribeELCAlarmDatas = () => {
  client.unsubscribe(subscribeTopics.ELC_ALARMDATAS, err => {
    console.log('mqtt remove', 'ELC_ALARMDATA', err);
    if (!err) messageHandler[subscribeTopics.ELC_ALARMDATAS] = null;
    else console.warn(err);
  });
};
//
export const subscribeElcAlarmMessage = callback => {
  client.subscribe(subscribeTopics.ELC_DASHBOARD_ALARMDATAS, err => {
    console.log('mqtt add', 'ELC_DASHBOARD_ALARMDATAS', err);
    if (!err) messageHandler[subscribeTopics.ELC_DASHBOARD_ALARMDATAS] = callback;
    else console.warn(err);
  });
};

export const unsubscribeElcAlarmMessage = () => {
  client.unsubscribe(subscribeTopics.ELC_DASHBOARD_ALARMDATAS, err => {
    console.log('mqtt remove', 'ELC_DASHBOARD_ALARMDATAS', err);
    if (!err) messageHandler[subscribeTopics.ELC_DASHBOARD_ALARMDATAS] = null;
    else console.warn(err);
  });
};

// 订阅箱变锁服务状态
export const subscribeElcService = callback => {
  client.subscribe(subscribeTopics.ELC_SERVICE_STATUS, err => {
    console.log('mqtt add', 'ELC_SERVICE_STATUS', err);
    if (!err) messageHandler[subscribeTopics.ELC_SERVICE_STATUS] = callback;
    else console.warn(err);
  });
};

// 取消订阅
export const unsubscribeElcService = () => {
  client.unsubscribe(subscribeTopics.ELC_SERVICE_STATUS, err => {
    console.log('mqtt remove', 'ELC_SERVICE_STATUS', err);
    if (!err) messageHandler[subscribeTopics.ELC_SERVICE_STATUS] = null;
    else console.warn(err);
  });
};

export const subscribeTasks = callback => {
  client.subscribe(subscribeTopics.TASKS, err => {
    console.log('mqtt add', 'TASKS', err);
    if (!err) messageHandler[subscribeTopics.TASKS] = callback;
    else console.warn(err);
  });
};

export const unsubscribeTasks = () => {
  client.unsubscribe(subscribeTopics.TASKS, err => {
    console.log('mqtt remove', 'TASKS', err);
    if (!err) messageHandler[subscribeTopics.TASKS] = null;
    else console.warn(err);
  });
};

export const subscribeLatestTasks = callback => {
  client.subscribe(subscribeTopics.DASHBOARD_LATEST_TASKS, err => {
    console.log('mqtt add', 'DASHBOARD_LATEST_TASKS', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_LATEST_TASKS] = callback;
    else console.warn(err);
  });
};

export const unsubscribeLatestTasks = () => {
  client.unsubscribe(subscribeTopics.DASHBOARD_LATEST_TASKS, err => {
    console.log('mqtt remove', 'DASHBOARD_LATEST_TASKS', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_LATEST_TASKS] = null;
    else console.warn(err);
  });
};

export const subscribeTasksDownload = callback => {
  client.subscribe(subscribeTopics.TASKS_DOWNLOAD, err => {
    console.log('mqtt add', 'TASKS_DOWNLOAD', err);
    if (!err) messageHandler[subscribeTopics.TASKS_DOWNLOAD] = callback;
    else console.warn(err);
  });
};

export const unsubscribeTasksDownlad = () => {
  client.unsubscribe(subscribeTopics.TASKS_DOWNLOAD, err => {
    console.log('mqtt remove', 'TASKS_DOWNLOAD', err);
    if (!err) messageHandler[subscribeTopics.TASKS_DOWNLOAD] = null;
    else console.warn(err);
  });
};

export const subscribeLatestAuthoritys = callback => {
  client.subscribe(subscribeTopics.DASHBOARD_LATEST_AUTHORITYS, err => {
    console.log('mqtt add', 'DASHBOARD_LATEST_AUTHORITYS', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_LATEST_AUTHORITYS] = callback;
    else console.warn(err);
  });
};

export const unsubscribeLatestAuthoritys = () => {
  client.unsubscribe(subscribeTopics.DASHBOARD_LATEST_AUTHORITYS, err => {
    console.log('mqtt remove', 'DASHBOARD_LATEST_AUTHORITYS', err);
    if (!err) messageHandler[subscribeTopics.DASHBOARD_LATEST_AUTHORITYS] = null;
    else console.warn(err);
  });
};

export const subscribeBIStatistics = callback => {
  client.subscribe(subscribeTopics.BI_STATISTIC, err => {
    console.log('mqtt add', 'BI_STATISTIC', err);
    if (!err) messageHandler[subscribeTopics.BI_STATISTIC] = callback;
    else console.warn(err);
  });
};

export const unsubscribeBIStatistics = () => {
  client.unsubscribe(subscribeTopics.BI_STATISTIC, err => {
    console.log('mqtt remove', 'BI_STATISTIC', err);
    if (!err) messageHandler[subscribeTopics.BI_STATISTIC] = null;
    else console.warn(err);
  });
};

export const subscribeBIKeyBoxStatistics = callback => {
  client.subscribe(subscribeTopics.BI_KEYBOX_STATISTIC, err => {
    console.log('mqtt add', 'BI_KEYBOX_STATISTIC', err);
    if (!err) messageHandler[subscribeTopics.BI_KEYBOX_STATISTIC] = callback;
    else console.warn(err);
  });
};

export const unsubscribeBIKeyBoxStatistics = () => {
  client.unsubscribe(subscribeTopics.BI_KEYBOX_STATISTIC, err => {
    console.log('mqtt remove', 'BI_KEYBOX_STATISTIC', err);
    if (!err) messageHandler[subscribeTopics.BI_KEYBOX_STATISTIC] = null;
    else console.warn(err);
  });
};

export const subscribeBIKeyBoxTakeoutin = callback => {
  client.subscribe(subscribeTopics.BI_KEYBOX_TAKEOUTIN, err => {
    console.log('mqtt add', 'BI_KEYBOX_TAKEOUTIN', err);
    if (!err) messageHandler[subscribeTopics.BI_KEYBOX_TAKEOUTIN] = callback;
    else console.warn(err);
  });
};

export const unsubscribeBIKeyBoxTakeoutin = () => {
  client.unsubscribe(subscribeTopics.BI_KEYBOX_TAKEOUTIN, err => {
    console.log('mqtt remove', 'BI_KEYBOX_TAKEOUTIN', err);
    if (!err) messageHandler[subscribeTopics.BI_KEYBOX_TAKEOUTIN] = null;
    else console.warn(err);
  });
};

export const subscribeBITaskDatas = callback => {
  client.subscribe(subscribeTopics.BI_TASK_DATAS, err => {
    console.log('mqtt add', 'BI_TASK_DATAS', err);
    if (!err) messageHandler[subscribeTopics.BI_TASK_DATAS] = callback;
    else console.warn(err);
  });
};

export const unsubscribeBITaskDatas = () => {
  client.unsubscribe(subscribeTopics.BI_TASK_DATAS, err => {
    console.log('mqtt remove', 'BI_TASK_DATAS', err);
    if (!err) messageHandler[subscribeTopics.BI_TASK_DATAS] = null;
    else console.warn(err);
  });
};

export const subscribeBILockSwicthList = callback => {
  client.subscribe(subscribeTopics.BI_LOCKSWITCH_RECORDS, err => {
    console.log('mqtt add', 'BI_LOCKSWITCH_RECORDS', err);
    if (!err) messageHandler[subscribeTopics.BI_LOCKSWITCH_RECORDS] = callback;
    else console.warn(err);
  });
};

export const unsubscribeBILockSwicthList = () => {
  client.unsubscribe(subscribeTopics.BI_LOCKSWITCH_RECORDS, err => {
    console.log('mqtt remove', 'BI_LOCKSWITCH_RECORDS', err);
    if (!err) messageHandler[subscribeTopics.BI_LOCKSWITCH_RECORDS] = null;
    else console.warn(err);
  });
};

export const subscribeBIAnalyzeDataChart = callback => {
  client.subscribe(subscribeTopics.BI_ANALYZEDATA_CHART, err => {
    console.log('mqtt add', 'BI_ANALYZEDATA_CHART', err);
    if (!err) messageHandler[subscribeTopics.BI_ANALYZEDATA_CHART] = callback;
    else console.warn(err);
  });
};

export const unsubscribeBIAnalyzeDataChart = () => {
  client.unsubscribe(subscribeTopics.BI_ANALYZEDATA_CHART, err => {
    console.log('mqtt remove', 'BI_ANALYZEDATA_CHART', err);
    if (!err) messageHandler[subscribeTopics.BI_ANALYZEDATA_CHART] = null;
    else console.warn(err);
  });
};

export const subscribeBITaskDownLoad = callback => {
  client.subscribe(subscribeTopics.BI_TASK_DOWNLOAD, err => {
    console.log('mqtt add', 'BI_TASK_DOWNLOAD', err);
    if (!err) messageHandler[subscribeTopics.BI_TASK_DOWNLOAD] = callback;
    else console.warn(err);
  });
};

export const unsubscribeBITaskDownLoad = () => {
  client.unsubscribe(subscribeTopics.BI_TASK_DOWNLOAD, err => {
    console.log('mqtt remove', 'BI_TASK_DOWNLOAD', err);
    if (!err) messageHandler[subscribeTopics.BI_TASK_DOWNLOAD] = null;
    else console.warn(err);
  });
};
